__turbopack_context__.v({
  "deliveryInstructions": "hqy1lW_deliveryInstructions",
  "mapContainer": "hqy1lW_mapContainer",
  "searchInput": "hqy1lW_searchInput",
  "submitButton": "hqy1lW_submitButton",
});
